import { getAdminAuthHeaders } from './adminApi';

const API_BASE_URL = process.env.REACT_APP_GOTTEA_API_BASE_URL || 'https://gottea-search-5gtrn.ondigitalocean.app';

async function getAuthHeaders() {
  return getAdminAuthHeaders();
}

async function parseResponse(response) {
  const body = await response.json().catch(() => ({}));

  if (!response.ok || body.success === false) {
    throw new Error(body.error || body.message || `Request failed with status ${response.status}`);
  }

  return body.data || body;
}

async function request(path, options = {}) {
  const authHeaders = await getAuthHeaders();
  const headers = {
    ...authHeaders,
    ...(options.body instanceof FormData ? {} : { 'Content-Type': 'application/json' }),
    ...(options.headers || {}),
  };

  const response = await fetch(`${API_BASE_URL}${path}`, {
    ...options,
    headers,
  });

  return parseResponse(response);
}

export async function fetchRewards() {
  const data = await request('/loyalty/admin/rewards');
  return data.rewards || [];
}

export async function createReward(payload) {
  const data = await request('/loyalty/admin/rewards', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
  return data.reward;
}

export async function updateReward(rewardId, payload) {
  const data = await request(`/loyalty/admin/rewards/${rewardId}`, {
    method: 'PUT',
    body: JSON.stringify(payload),
  });
  return data.reward;
}

export async function deactivateReward(rewardId) {
  return request(`/loyalty/admin/rewards/${rewardId}`, {
    method: 'DELETE',
  });
}

export async function uploadRewardImage(rewardId, imageFile) {
  const formData = new FormData();
  formData.append('image', imageFile);

  const data = await request(`/loyalty/admin/rewards/${rewardId}/image`, {
    method: 'POST',
    body: formData,
  });

  return data.reward;
}
